import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";

import TransaccionesCliente from "../containers/TransaccionesCliente";
import ClienteProspeccion from "./ClienteProspeccion/ClienteProspeccion";
import { AUTOSERVICE_PAYMENT } from "app/config/globals";
import TransaccionalContext from "../context/TransaccionalContext";

const SwitchProspeccion = () => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const history = useHistory();

  const identificacionHistory =
    history?.location?.state?.state?.identificacion || "";

  const cedulaStorage = localStorage.getItem("cedula");
  const stateStorage = localStorage.getItem("station");
  const idGrupo = localStorage.getItem("idGrupoStorage");

  // Por si quieres seguir usando datosBusqueda
  const [datosBusqueda, setDatosBusqueda] = useState({
    identificacion: identificacionHistory,
    mostrarBuscador: true,
    idGrupo: idGrupo,
    idMovimiento: 0,
    menuMobile: true,
  });

  // Validación: si son iguales renderiza TransaccionesCliente, si no ClienteProspeccion
  const existeClienteProspeccion =
    String(identificacionHistory) === String(cedulaStorage);

  const reddirectPagueApui = String(stateStorage) === AUTOSERVICE_PAYMENT;

  useEffect(() => {
    if (reddirectPagueApui) {
      setDatosBusqueda((prev) => ({
        ...prev,
        idMovimiento: 9,
        idGrupo: 1,
        menuMobile: false,
      }));

      setInformacionTransaccional((args) => ({
        ...args,
        opcionMenu: 9,
      }));
    }
  }, [reddirectPagueApui]);

  return (
    <>
      {existeClienteProspeccion ? (
        <ClienteProspeccion
          datosBusqueda={datosBusqueda}
          setDatosBusqueda={setDatosBusqueda}
        />
      ) : (
        <TransaccionesCliente />
      )}
    </>
  );
};

export default SwitchProspeccion;
